<template>
  <!-- 是否送礼 -->
  <el-dialog top="30vh" title="" :visible.sync="ticketPayDialog">
    <div class="first-gift">
      <img class="header" src="@/assets/img/dialog/header2025.png" alt="" />
      <img class="close" @click="toggleTicketPayDialog(false)" src="./img/close.png" alt="" />

      <div class="row1">
        <img src="./img/gsHeader.png" style="width: 0.55rem; height: 0.55rem; 
  top: 0.5rem; margin: 0.1rem 0;">
        <div style="font-family: PingFang SC;
font-weight: 500;
font-size: 0.16rem;
color: #000000;
">
          本场直播高清观看需要消耗<span> 1张 </span>观赛券
        </div>
      </div>
      <div class="row2" style="font-family: PingFang SC;
font-weight: 400;
font-size: 0.14rem;
color: #8D92A6;

">
        当前剩余 <span style="font-family: PingFang SC;
font-weight: 600;
font-size: 0.15rem;
color: #000000;

"> &nbsp;{{ ticket }}张&nbsp; </span>观赛券。
      </div>
      <img src="./img/ico.png" style="width: 2.5rem; 
   margin-top: 0.1rem;">
      <div v-if="ticket == 0" class="btn btn-active" @click="private">私信主播, 获取观赛券!</div>
      <div v-else class="btn btn-active" @click="confirm">使用观赛券</div>
    </div>
  </el-dialog>
</template>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  import {
    post
  } from "../../util/http";
  import { getCustomerServiceLink } from "@/util/common";
  export default {
    computed: {
      ...mapState(["userInfo", "appConfig", "ticket", "ticketPayDialog", "ticketAnchor", "isNeedRefresh"]),
    },
    props: {},

    data() {
      return {};
    },
    created() {},
    destroyed() {},
    mounted() {},
    methods: {
      ...mapMutations(["changeTicket","toggleTicketPayDialog", "changeAnchorId"]),
      ...mapActions(["getChatConfig", "getUserBackpack", "getChatList"]),
      private(){
        const isLiveRoom = this.$route.path.indexOf("/liveMatchesTwo/") === 0;
        this.changeAnchorId(this.ticketAnchor.id);
        if (this.$listeners.changePrivateChat) {
          this.$emit("changePrivateChat", true);
        } else if (isLiveRoom) {
          window.dispatchEvent(new CustomEvent("open-live-private-chat"));
        } else if (Number(this.appConfig.kf_toggle) === 1) {
          const link = getCustomerServiceLink(this.appConfig);
          if (link) {
            window.open(link, "_blank");
          }
        } else {
          this.$router.push("/user-center/privateChat");
        }
        this.toggleTicketPayDialog(false);
      },
      confirm() {
       
        post({
            url: "/api/live/ticket",
            data: {
              uid: this.userInfo.id,
              anchor_id: this.ticketAnchor.id,
            },
          })
          .then(({
            data
          }) => {
            if (data.status === 0) {
              this.$message.success("观赛券已使用，为您开启高清赛事。");
              this.$router.push(`/liveMatchesTwo/${this.ticketAnchor.id}`);
              this.toggleTicketPayDialog(false);
              this.getUserBackpack();
              if (this.isNeedRefresh) {
                window.location.reload();
              }
            }
          })
          .catch((err) => console.log("err", err));
      },
    },
  };
</script>

<style scoped lang="scss">
  ::v-deep {
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog {
      width: 4.7rem;
      background: linear-gradient(180deg, #E6F2FF 0%, #FFFFFF 57.74%);

      border-radius: 0.16rem;
    }
  }

  .header {
    height: 1.5rem;
    position: absolute;
    top: -0.34rem;
  }

  .header-bg {
    height: 2rem;
    position: absolute;
    top: -2rem;
    z-index: -1;
  }

  .close {
    position: absolute;
    width: 0.2rem;
    //bottom: -0.56rem;
    left: 4.2rem;
    right: 0;
    margin: 0 auto;
    cursor: pointer;
  }

  .help {
    position: absolute;
    width: 0.24rem;
    top: 0.12rem;
    right: 0.12rem;
  }

  .first-gift {

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.2rem;

    .row1 {
      color: #333333;
      font-size: 0.18rem;
      margin-top: 0.45rem;
      display: flex;
      flex-direction: column;
      /* align-items: center; */
      align-items: center;

      span {
        color: var(--theme-primary);
      }
    }

    .row2 {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 0.15rem;
      cursor: pointer;
      margin-top: 0.1rem;

      span {
        color: var(--theme-primary);
      }
    }

    .btn {
      width: 80%;
      height: 0.48rem;
      background: var(--theme-primary);

      box-shadow: 0px 4px 8px rgba(48, 185, 188, 0.2);
      border-radius: 6px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
      font-size: 0.16rem;
    }
  }
</style>